import Navigation from './components/Navigation'
import CreateStartup from './components/CreateStartup'
import ConfirmEmail from './components/ConfirmEmail'
import ParticipantProfile from './components/ParticipantProfile'
import StartupdatahalfYear from './components/StartupdatahalfYear'
import TalentScore from './components/TalentScore'
import StartupdataYear from './components/StartupdataYear'
import Map from './components/Map'
import Footer from './components/Footer'

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
function App() {
    return (
        <div className="App">
            <Router>
                <Navigation />
                <Switch>
                    <Route path="/" exact component={Map} />
                    <Route path="/confirm-email/:startupId/:code" component={ConfirmEmail} />
                    <Route path="/create-startup" component={CreateStartup} />
                    <Route path="/participant-profile/:startupId/:code" component={ParticipantProfile} type={"founder"} />
                    <Route path="/startupdata-halfyear/:startupId/:code" component={StartupdatahalfYear} type={"founder"} />
                    <Route path="/talent-score/:startupId/:code" component={TalentScore} type={"founder"} />
                    <Route path="/startupdata-year/:startupId/:code" component={StartupdataYear} type={"founder"} />
                    <Route path="/user-profile/:startupId/:code" component={ParticipantProfile} type={"user"} />
                </Switch>
                <Footer />
            </Router>
        </div>
    )
}

export default App
